<template>
  <div
    class="
      flex-col
      justify-between
      items-center
      shadow
      border-gray-200
      bg-gray-50
      border
      overflow-hidden
      rounded-lg
      px-4
      py-5
      sm:p-6
      mb-14
    "
  >
    <div class="flex items-center">
      <CalendarIcon class="h-9 w-9 text-vice-teal-500 mr-4"></CalendarIcon>
      <div>
        <h3 class="text-lg font-medium flex items-center">Session is ready to enter</h3>

        <Transition name="fade">
          <ViceBadge red small v-show="!!sessionStartsIn">
            {{ sessionStartsIn }}
          </ViceBadge>
        </Transition>
      </div>
    </div>

    <slot name="actions"></slot>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import { CalendarIcon } from '@heroicons/vue/outline';

import ViceBadge from '@/Components/Badges/ViceBadge.vue';
import DateFormatMixin from '@/Mixins/DateFormatMixin.vue';

import useTourManager from '@/Composables/useTourManager';
import { userSessionDetailsTourSteps } from '@/Data/tourSteps';

const userSessionDetailsTour = useTourManager(
  'userSessionDetailsTour',
  userSessionDetailsTourSteps,
);
dayjs.extend(duration);
dayjs.extend(relativeTime);

export default {
  name: 'SessionEntryCard',
  mixins: [DateFormatMixin],
  emits: ['openSessionEntryWizard'],
  components: {
    CalendarIcon,
    ViceBadge,
  },
  data() {
    return {
      message: '',
      session: this.$page.props.session,

      sessionStartsIn: '',
    };
  },
  mounted() {
    this.sessionStartsIn = this.updateSessionStartTime();
    setInterval(() => {
      this.sessionStartsIn = this.updateSessionStartTime();
    }, 10000);
    setTimeout(() => {
      userSessionDetailsTour.startTour();
    }, 500);
  },
  methods: {
    updateSessionStartTime() {
      const now = dayjs(); // todays date
      const start = dayjs(this.session.details.session_start_by_timezone);
      const end = dayjs(this.session.details.session_end_by_timezone);
      const durationMoment = dayjs.duration(start.diff(now));
      const seconds = durationMoment.asSeconds();

      if (now.isAfter(end)) return 'Finished';
      if (seconds <= 0) return 'Has started!';
      if (seconds > 3600 * 24) return null;
      return `Starts in ${dayjs.duration(seconds, 'seconds').humanize()}`;
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
